import { CONNECTAD_PROBE, connectadIsTarget } from "./config";
import { bump, pushSample } from "./sink";

function analyze(url: string, status: number, body: string): void {
  if (Math.random() > CONNECTAD_PROBE.sampleRate) return;

  bump("net/req");
  bump(`net/http_${status === 200 ? "200" : "other"}`);

  let parsed: any = null;
  try { parsed = JSON.parse(body || "null"); } catch { /* no-op */ }

  const decisions = parsed && parsed.decisions;
  const ids = decisions && typeof decisions === "object" ? Object.keys(decisions) : [];

  if (!ids.length) {
    bump("net/empty");
    return;
  }

  bump("net/has_decision");

  let anyPrice = false;
  let decisionNoPrice = false;
  ids.forEach((id) => {
    const d = decisions[id] || {};
    const price = d.pricing && d.pricing.clearPrice;
    if (price) anyPrice = true;
    else decisionNoPrice = true;
  });

  bump(anyPrice ? "net/has_price" : "net/no_price");

  if (decisionNoPrice && !anyPrice) {
    pushSample("_samples_noprice", {
      ts: new Date().toISOString(),
      url: url.slice(0, 500),
      body: (body || "").slice(0, 20000),
    });
  }
}

export function installNetworkProbe(): void {
  const w = window as any;

  const origFetch = w.fetch;
  if (typeof origFetch === "function") {
    w.fetch = function (this: any, ...args: any[]) {
      const req = args[0];
      const url = typeof req === "string" ? req : (req && req.url) || "";
      const p = origFetch.apply(this, args);
      if (connectadIsTarget(url)) {
        p.then((resp: any) => {
          try { resp.clone().text().then((t: string) => analyze(url, resp.status, t)); } catch { /* no-op */ }
        }).catch(() => { /* no-op */ });
      }
      return p;
    };
  }

  const XHR = w.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    const origOpen = XHR.prototype.open;
    const origSend = XHR.prototype.send;
    XHR.prototype.open = function (this: any, method: string, url: string, ...rest: any[]) {
      this.__caUrl = url;
      return origOpen.call(this, method, url, ...rest);
    };
    XHR.prototype.send = function (this: any, ...sendArgs: any[]) {
      const url = this.__caUrl || "";
      if (connectadIsTarget(url)) {
        this.addEventListener("loadend", () => {
          try { analyze(url, this.status, this.responseText); } catch { /* no-op */ }
        });
      }
      return origSend.apply(this, sendArgs);
    };
  }
}
